/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiAuthBarberLogoutMutationResponse, PostApiAuthBarberLogout401 } from "../entities/PostApiAuthBarberLogout";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiAuthBarberLogout } from "../api/postApiAuthBarberLogout";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiAuthBarberLogoutMutationKey = () => [{ url: '/api/auth/barber/logout' }] as const

export type PostApiAuthBarberLogoutMutationKey = ReturnType<typeof postApiAuthBarberLogoutMutationKey>

export function postApiAuthBarberLogoutMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = postApiAuthBarberLogoutMutationKey()
        return mutationOptions<PostApiAuthBarberLogoutMutationResponse, ResponseErrorConfig<PostApiAuthBarberLogout401>, void, TContext>({
          mutationKey,
          mutationFn: async() => {
            return postApiAuthBarberLogout(config)
          },
        })

}

/**
 * @description Очистить файлы cookie для авторизации мастера
 * @summary Выход из системы мастера
 * {@link /api/auth/barber/logout}
 */
export function usePostApiAuthBarberLogout<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiAuthBarberLogoutMutationResponse, ResponseErrorConfig<PostApiAuthBarberLogout401>, void, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiAuthBarberLogoutMutationKey()

          const baseOptions = postApiAuthBarberLogoutMutationOptions(config) as UseMutationOptions<PostApiAuthBarberLogoutMutationResponse, ResponseErrorConfig<PostApiAuthBarberLogout401>, void, TContext>
          

          return useMutation<PostApiAuthBarberLogoutMutationResponse, ResponseErrorConfig<PostApiAuthBarberLogout401>, void, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiAuthBarberLogoutMutationResponse, ResponseErrorConfig<PostApiAuthBarberLogout401>, void, TContext>
      
}